import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/feedback/types')({
  beforeLoad: () => {
    throw redirect({ to: '/settings/feedback-types' });
  },
});
